import { render, staticRenderFns } from "./newsListDetail.vue?vue&type=template&id=694e329e&scoped=true&"
import script from "./newsListDetail.vue?vue&type=script&lang=js&"
export * from "./newsListDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsListDetail.vue?vue&type=style&index=0&id=694e329e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694e329e",
  null
  
)

export default component.exports